/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ------------------------------------------------------------------
   * Wue — variant-aware personalisation fields
   *
   * snippets/product.liquid renders ONE personalisation input, chosen by
   * product tag (P12, P10, P8, P40, Engraved, Roman, Initials, Monogram,
   * Year). That is a page-render decision, so the box shows on every variant
   * of every tagged product.
   *
   * This script layers behaviour on top without touching the 126KB snippet,
   * and builds the fields the By Wue range needs, which the tag chain
   * cannot render:
   *
   *   1. The 80-character card message, shown only when the card option is
   *      the write-your-own value.
   *   2. The initials box on Alphabet products, sized by the "Number of
   *      initials" option.
   *   3. The photo upload, shown only when the card option is "your photo".
   *   4. The two family initials boxes on the family pieces.
   *   5. The three date boxes on the Roman numeral pieces.
   *   6. The two free-text boxes on pieces sold as a pair.
   *   7. The year, postcode and monogram boxes, each with its own limit and
   *      its own idea of what counts as valid.
   *   8. The two stacked initials boxes on the couple pieces.
   *
   * CHANGING THIS FILE IS EXPENSIVE. There is no patch API: every edit is a
   * full re-upload, and writes to the live theme are blocked, so each change
   * means duplicate, upload, preview, publish. Batch edits, and prefer
   * making copy editable from the admin (see the "Examples:" and "Field
   * Label:" tags below) over hardcoding a sentence that will want tuning
   * later.
   *
   * TWO DIFFERENT THINGS, TWO DIFFERENT FIELDS — read this before merging
   * them back together.
   *
   * The ENGRAVING belongs to the product. What goes on the piece does not
   * depend on which card the customer picks, so it shows on EVERY variant.
   * It is the theme's own properties[Personalisation] box from the tag
   * chain, and its length comes from TAG_RULES below.
   *
   * The CARD MESSAGE belongs to the card. It shows only when the card
   * option is the write-your-own value, and it is built here as
   * properties[Card message].
   *
   * Until 12 Oct both were named properties[Personalisation] and shared one
   * visibility group, which broke both ways: on a preset-card variant of an
   * engraved product the engraving box was hidden, so a customer could buy a
   * hand-stamped piece without ever saying what to stamp on it; and on the
   * write-your-own variant two inputs carried the same property name, so
   * only one of the two values reached the order. Keep them separate.
   *
   * The legacy range is the one exception, preserved by isLegacyToggleValue:
   * products whose option value begins "yes" ("yes please - hand stamp my
   * gift box (+£3)") genuinely should hide the box until it is paid for.
   *
   * SCRIPTED REPLACEMENTS. Seven tags — FAMILY_INITIALS_TAG, ROMAN_DATE_TAG,
   * PAIRED_TEXT_TAG, YEAR_TAG, POSTCODE_TAG, MONOGRAM_TAG and
   * COUPLE_INITIALS_TAG — take the theme's free-text box away entirely and
   * put purpose-built fields in its place. All go through
   * stripThemePersonalisation(), which hides the theme boxes AND strips
   * their names; hiding alone would still post an empty property. A product
   * should carry at most one of those tags.
   *
   * Leave the product's P-tag in place alongside the scripted one. The theme
   * box it renders is stripped immediately, but if this script ever fails to
   * load the customer still gets a plain box rather than a personalised
   * product with nowhere to type.
   *
   * CONDITIONAL ENGRAVING. A product tagged 'Engrave If: <option value>'
   * keeps the theme's box but shows it only on the variants carrying that
   * value. Built for the Key to Happiness keyring, where the preset endings
   * need no typing and 'something else' does.
   *
   * PHOTO UPLOAD — read this before touching initPhotoField.
   *
   * Shopify accepts file uploads fine: POST multipart to /cart/add with an
   * input named properties[...] and it stores the file and puts its CDN URL
   * on the line item. The form already carries enctype="multipart/form-data".
   *
   * THE THEME'S OWN ADD-TO-CART HANDLER DOES NOT. With a file input present
   * in the product form it swallows the click and never reaches the cart —
   * no request, no error, nothing. It does this whether or not a file has
   * been chosen, and it breaks EVERY variant of that product, not just the
   * photo one. This took the whole By Wue range offline on 3 Oct.
   *
   * Hence the two rules below, both load-bearing:
   *   1. The file input is DETACHED from the form on every variant that is
   *      not the photo one, so the theme behaves exactly as it always has.
   *   2. On the photo variant the theme's handler is stopped and the form is
   *      submitted natively instead, which uploads the file and lands the
   *      customer on /cart.
   *
   * Do not "simplify" either of those away, and do not leave the input in
   * the form disabled-but-present without testing a real add to cart.
   *
   * LAYOUT: each box is placed immediately after the variant selector that
   * governs it. .product__selectors is a GRID — one column on narrow
   * screens, two from about 1100px up — so anything dropped into it without
   * grid-column: 1 / -1 silently lands in the second column, beside the
   * selector instead of under it.
   *
   * .pName is already display:block, so the theme's <label><br><input>
   * pattern leaves a full empty line between label and box. The fields
   * built here drop the <br> and use margins instead.
   * ------------------------------------------------------------------ */

  var PERSONALISATION_PROPS = [
    'Personalisation', 'day', 'month', 'year', 'initials', 'Monogram'
  ];

  // Most specific first — the theme's if/elsif chain tests P12 first, which
  // is wrong given how widely P12 is applied.
  var TAG_RULES = [
    { tag: 'P4',       max: 4,  label: 'Personalisation' },
    { tag: 'Engraved', max: 12, label: 'Engraving' },
    { tag: 'P40',      max: 40, label: 'Personalisation' },
    { tag: 'P10',      max: 10, label: 'Personalisation' },
    { tag: 'P8',       max: 8,  label: 'Personalisation' },
    { tag: 'P12',      max: 12, label: 'Personalisation' }
  ];

  var ERROR_TEXT = 'Please add your personalisation before adding to bag.';
  var CUSTOM_CARD_ERROR_TEXT = 'Please add your message before adding to bag.';

  /* The write-your-own card value. "custom message" is the original By Wue
   * wording and "your own message" the current one — BOTH are matched so the
   * option values can be renamed without the message box disappearing.
   *
   * Load-bearing: rename the option value to something not in this list and
   * the box silently stops appearing. */
  var CUSTOM_CARD_VALUES = ['custom message', 'your own message'];

  /* The card message has its own property name so it can sit alongside the
   * engraving box on the write-your-own variant. Two inputs sharing one
   * properties[] name means only one value reaches the order. */
  var CARD_MESSAGE_PROP = 'Card message';
  var CARD_MESSAGE_LABEL = 'Your message';

  /* The family pieces. Tag a product with FAMILY_INITIALS_TAG and its single
   * free-text engraving box is replaced by two initials boxes and a preview
   * of the finished piece. */
  var FAMILY_INITIALS_TAG = 'Family Initials';
  var FAMILY_PARENTS_PROP = 'Parents initials';
  var FAMILY_CHILDREN_PROP = 'Children initials';
  var FAMILY_HEART = '♡';

  /* The Roman numeral pieces. Tag a product with ROMAN_DATE_TAG and its
   * free-text box is replaced by three date boxes, a live conversion, and a
   * hidden property carrying the numerals the piece is stamped with.
   *
   * The separator is a full stop with spaces, which is what the pieces are
   * actually stamped with — see the coaster photography, XXVIII . V . MMXXII.
   * It was a middot until 12 Oct, which quietly promised the customer
   * something different from what they would receive. */
  var ROMAN_DATE_TAG = 'Roman Date';
  var ROMAN_DAY_PROP = 'Day';
  var ROMAN_MONTH_PROP = 'Month';
  var ROMAN_YEAR_PROP = 'Year';
  var ROMAN_RESULT_PROP = 'Roman numerals';
  var ROMAN_SEPARATOR = ' . ';

  /* Pieces sold as a pair. One box cannot describe both halves, so this
   * builds two. Labels and property names follow the product type, so the
   * order reads "Tag 1 / Tag 2" on luggage tags and "Coaster 1 / Coaster 2"
   * on coasters rather than something generic the bench has to interpret.
   *
   * THE EXAMPLES ARE EDITABLE FROM THE ADMIN. Add a product tag beginning
   * "Examples:" and the rest of it becomes the help line under the boxes, so
   * the wording can lead with whatever suits that listing — Mr & Mrs opens
   * with Mr & Mrs, the anniversary pieces open wider. No theme change
   * needed, which matters because every theme change is a full re-upload.
   *
   * Separate the examples with " / ", never commas — the Shopify admin
   * splits a typed tag on commas and you would end up with several tags. */
  var PAIRED_TEXT_TAG = 'Paired Text';
  var PAIRED_TEXT_MAX = 20;
  var PAIRED_TEXT_EXAMPLES_PREFIX = 'examples:';
  var PAIRED_TEXT_DEFAULT_EXAMPLES = 'Man / Wife / Hubby / Wifey / a name or a date';
  var PAIRED_TEXT_HELP_TAIL = ' Each one is embossed exactly as you write it.';
  var PAIRED_TEXT_NAMES = [
    { match: 'luggage', one: 'Tag 1', two: 'Tag 2' },
    { match: 'coaster', one: 'Coaster 1', two: 'Coaster 2' }
  ];
  var PAIRED_TEXT_DEFAULT = { one: 'Piece 1', two: 'Piece 2' };

  /* A year and nothing else. Two digits or four, because '98 and 1998 are
   * both how people write the year they mean; three digits is a typo, and a
   * typo here is engraved. */
  var YEAR_TAG = 'Year Field';
  var YEAR_PROP = 'Year';
  var YEAR_LABEL = 'Your year';
  var YEAR_HELP = 'Two digits or four — 98 or 1998.';
  var YEAR_ERROR = 'Please add the year before adding to bag.';
  var YEAR_INVALID = 'Please enter a year as two digits or four — 98 or 1998.';

  /* UK postcodes have a shape, and checking it catches the transpositions
   * and dropped letters that would otherwise be embossed and shipped. */
  var POSTCODE_TAG = 'Postcode Field';
  var POSTCODE_PROP = 'Postcode';
  var POSTCODE_LABEL = 'Your postcode';
  var POSTCODE_HELP = 'The full postcode, with the space — SW1A 1AA.';
  var POSTCODE_ERROR = 'Please add the postcode before adding to bag.';
  var POSTCODE_WARNING = 'That does not look like a UK postcode. It will be embossed exactly as written.';
  var POSTCODE_PATTERN = /^[A-Z]{1,2}[0-9][A-Z0-9]?\s*[0-9][A-Z]{2}$/;

  /* A monogram is up to three letters in a row. The theme's box had no limit
   * at all, so a customer could type a sentence into a field that engraves
   * three characters. */
  var MONOGRAM_TAG = 'Monogram Field';
  var MONOGRAM_PROP = 'Monogram';
  var MONOGRAM_LABEL = 'Your monogram';
  var MONOGRAM_MAX = 3;
  var MONOGRAM_HELP = 'Up to three letters, in the order they are embossed.';
  var MONOGRAM_ERROR = 'Please add the monogram before adding to bag.';

  /* The couple pieces: two initials stacked with a horizontal rule between
   * them, as on the Couple Shield and the golf ball marker.
   *
   *     A
   *    ---
   *     W
   *
   * Two boxes, not one. A single run says nothing about where the split
   * falls or which pair sits above the line, and that only surfaces as a
   * remake.
   *
   * Letters per side defaults to two and is set per product with a
   * 'Letters Per Side: 1' tag — the shield has room for TE over RE, the
   * golf ball marker is a 25mm disc and takes one letter each. */
  var COUPLE_INITIALS_TAG = 'Couple Initials';
  var COUPLE_TOP_PROP = 'Top initial';
  var COUPLE_BOTTOM_PROP = 'Bottom initial';
  var COUPLE_PER_SIDE_PREFIX = 'letters per side:';
  var COUPLE_PER_SIDE_DEFAULT = 2;

  /* Admin-editable: 'Engrave If: something else' on a product shows its
   * engraving box only on variants whose option value is "something else".
   * Matching ignores case and surrounding space. */
  var ENGRAVE_IF_PREFIX = 'engrave if:';

  /* Admin-editable: 'Field Label: Your ending' replaces the wording above the
   * theme's engraving box on that one product. The tag chain can only give
   * every P12 product the same "Personalisation (max 12 characters)", which
   * is wrong wherever the box means something specific — the ending on the
   * Key to Happiness keyring, say. Copy is the thing most likely to want
   * changing, and this keeps it out of the theme. */
  var FIELD_LABEL_PREFIX = 'field label:';

  /* The photo card value. Same load-bearing rule as above: rename the option
   * value and the upload field silently stops appearing. */
  var PHOTO_CARD_VALUES = ['your photo'];
  var PHOTO_PROP = 'Your photo';
  var PHOTO_LABEL = 'Your photo';
  var PHOTO_HELP = 'JPG or PNG, up to 20MB. Printed in black and white and cropped square, so keep your subject central. We print it as you send it.';
  var PHOTO_ERROR_TEXT = 'Please choose a photo before adding to bag.';
  var PHOTO_PLACEHOLDER = 'Choose a photo';
  var PHOTO_MAX_BYTES = 20 * 1024 * 1024;
  var PHOTO_UID = 0;

  var INITIALS_OPTION_NAME = 'number of initials';
  var INITIALS_PROP = 'Initial(s)';
  var INITIALS_HELP = 'Letters only - in your preferred order.';

  var LABEL_GAP = '4px';
  var HELP_GAP = '8px';

  function normalise(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  /* Plain integer to Roman numerals. Returns '' outside 1–3999, which is
   * what empty and nonsense boxes give, so callers can test the result
   * rather than the input. */
  function toRoman(value) {
    var n = parseInt(value, 10);
    if (!(n >= 1 && n <= 3999)) return '';

    var map = [
      [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
      [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
      [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
    ];

    var out = '';
    for (var i = 0; i < map.length; i++) {
      while (n >= map[i][0]) {
        out += map[i][1];
        n -= map[i][0];
      }
    }
    return out;
  }

  /* The legacy range turns personalisation on with an option value beginning
   * "yes". That is the ONLY case where the engraving box should hide on some
   * variants — the customer has not paid for stamping yet. */
  function isLegacyToggleValue(value) {
    return normalise(value).indexOf('yes') === 0;
  }

  function isNewRangeCard(value) {
    return CUSTOM_CARD_VALUES.indexOf(normalise(value)) !== -1;
  }

  function isPhotoCard(value) {
    return PHOTO_CARD_VALUES.indexOf(normalise(value)) !== -1;
  }

  // Both write-your-own values get italicised in the dropdown.
  function isItalicCardValue(value) {
    return isNewRangeCard(value) || isPhotoCard(value);
  }

  function variantOptionValues(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3];
  }

  // product.options is an array of names; be tolerant of objects too.
  function rawOptionNames(product) {
    var raw = product.options_with_values || product.options || [];
    return raw.map(function (o) {
      return String(o && o.name != null ? o.name : o);
    });
  }

  function optionNames(product) {
    return rawOptionNames(product).map(function (n) {
      return n.trim().toLowerCase();
    });
  }

  function productTags(product) {
    return (product.tags || []).map(function (t) { return String(t); });
  }

  // Shopify's product JSON calls it `type`; be tolerant of product_type too.
  function productTypeOf(product) {
    return normalise(product.type || product.product_type || '');
  }

  // Which option holds the card choice, by looking for a write-your-own
  // value rather than assuming a name.
  function cardOptionIndex(product) {
    for (var i = 0; i < product.variants.length; i++) {
      var vals = variantOptionValues(product.variants[i]);
      for (var j = 0; j < vals.length; j++) {
        if (isNewRangeCard(vals[j]) || isPhotoCard(vals[j])) return j;
      }
    }
    return -1;
  }

  // Palo Alto wraps each variant selector in .selector-wrapper, with the
  // option name as its leading text.
  function findOptionWrapper(form, optionName) {
    if (!optionName) return null;
    var name = normalise(optionName);
    if (!name) return null;
    var wrappers = form.querySelectorAll('.selector-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      var txt = (wrappers[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt.indexOf(name) === 0) return wrappers[i];
    }
    return null;
  }

  /* Option VALUES are plain text — markup in them is escaped and shows up
   * literally — so the write-your-own choices are italicised here instead.
   * Purely cosmetic. */
  function italiciseCustomCardOption(scope) {
    if (!scope) return;
    var nodes = scope.querySelectorAll('.selector-wrapper *, .select-popout *, [data-popout-option]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;               // leaf nodes only
      if (!isItalicCardValue(el.textContent)) continue;
      el.style.fontStyle = 'italic';
    }
  }

  function placeAfter(anchor, node) {
    if (!anchor || !anchor.parentNode) return false;
    anchor.parentNode.insertBefore(node, anchor.nextSibling);
    return true;
  }

  function placeBeforeAddButton(form, node) {
    var addButton = form.querySelector('[name="add"], [data-add-to-cart]');
    var anchor = addButton
      ? (addButton.parentNode === form ? addButton : addButton.closest('form > *'))
      : null;
    if (anchor && anchor.parentNode === form) {
      form.insertBefore(node, anchor);
    } else {
      form.appendChild(node);
    }
  }

  // Full row, whichever container it lands in.
  function makeFieldWrapper() {
    var wrapper = document.createElement('div');
    wrapper.className = 'line-item-property__field';
    wrapper.style.gridColumn = '1 / -1';
    wrapper.style.width = '100%';
    return wrapper;
  }

  function makeErrorLine() {
    var error = document.createElement('small');
    error.className = 'pError';
    error.style.display = 'none';
    error.style.color = '#b00020';
    error.style.marginTop = '6px';
    error.style.fontSize = '0.85em';
    return error;
  }

  /* Takes the theme's tag-chain boxes out of play on a product whose fields
   * this script replaces. They are hidden AND lose their names, because a
   * hidden input with a properties[] name still posts an empty value next to
   * the scripted one. Returns the first wrapper so the replacement can be
   * dropped into the same place in the form. */
  function stripThemePersonalisation(form, inputs) {
    var anchor = null;
    var stripped = [];

    PERSONALISATION_PROPS.forEach(function (prop) {
      var input = form.querySelector('input[name="properties[' + prop + ']"]');
      if (!input) return;

      var wrapper = input.closest('.line-item-property__field');
      if (wrapper) {
        if (!anchor) anchor = wrapper;
        wrapper.style.display = 'none';
        wrapper.hidden = true;
      }

      input.required = false;
      input.removeAttribute('name');
      stripped.push(input);
    });

    return {
      anchor: anchor,
      inputs: inputs.filter(function (i) { return stripped.indexOf(i) === -1; })
    };
  }

  function buildCustomMessageField(form, product) {
    var wrapper = makeFieldWrapper();

    var label = document.createElement('label');
    label.className = 'pName';
    label.setAttribute('for', 'wue-custom-message');
    label.textContent = CARD_MESSAGE_LABEL;
    label.style.marginBottom = LABEL_GAP;

    var input = document.createElement('input');
    input.className = 'pBox';
    input.type = 'text';
    input.id = 'wue-custom-message';
    input.name = 'properties[' + CARD_MESSAGE_PROP + ']';
    input.setAttribute('maxlength', '80');
    input.style.display = 'block';

    var help = document.createElement('small');
    help.className = 'pHelp';
    help.textContent = 'Enter your message (maximum 80 characters).';
    help.style.display = 'block';
    help.style.marginTop = HELP_GAP;

    wrapper.appendChild(label);
    wrapper.appendChild(input);
    wrapper.appendChild(help);

    var idx = cardOptionIndex(product);
    var anchor = idx === -1
      ? null
      : findOptionWrapper(form, rawOptionNames(product)[idx]);

    if (!placeAfter(anchor, wrapper)) placeBeforeAddButton(form, wrapper);

    return input;
  }

  // Three ways the selected variant id changes: a native change event from a
  // radio or swatch, an attribute write, and a plain .value assignment from
  // the popout selector — which changes the property, not the attribute, so
  // the observer alone would miss it.
  function onVariantChange(form, idInput, cb) {
    form.addEventListener('change', function () { setTimeout(cb, 0); });

    if (window.MutationObserver) {
      new MutationObserver(cb).observe(idInput, {
        attributes: true, attributeFilter: ['value']
      });
    }

    var last = idInput.value;
    setInterval(function () {
      if (idInput.value !== last) { last = idInput.value; cb(); }
    }, 250);
  }

  /* The card message box, on its own toggle: shown only on variants whose
   * card option is the write-your-own value, and required while shown. */
  function initCardMessageField(product, form, idInput, input) {
    var idx = cardOptionIndex(product);
    if (idx === -1) return;

    var wrapper = input.closest('.line-item-property__field') || input.parentNode;
    if (!wrapper) return;

    var allowed = {};
    var found = false;
    product.variants.forEach(function (variant) {
      if (isNewRangeCard(variantOptionValues(variant)[idx])) {
        allowed[String(variant.id)] = true;
        found = true;
      }
    });
    if (!found) return;

    var error = makeErrorLine();
    error.textContent = CUSTOM_CARD_ERROR_TEXT;
    wrapper.appendChild(error);

    function sync() {
      var show = allowed[String(idInput.value)] === true;
      wrapper.style.display = show ? '' : 'none';
      wrapper.hidden = !show;
      // required must come off while hidden, or the browser refuses to
      // submit a form containing an invalid control it cannot focus
      input.required = show;
      if (!show) {
        input.value = '';
        error.style.display = 'none';
      }
    }

    function validate(event) {
      if (input.required !== true) return;
      if (input.value.trim() !== '') { error.style.display = 'none'; return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      error.style.display = 'block';
      input.focus();
    }

    onVariantChange(form, idInput, sync);

    form.addEventListener('submit', validate, true);
    var addBtn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', validate, true);

    sync();
  }

  /* Pieces sold as a pair: two free-text boxes, one per half.
   *
   * These products ship two items, so a single box cannot describe both and
   * whatever the customer typed had to be guessed at. Both boxes are
   * required — a pair with one side blank is a remake.
   *
   * Labels and property names come from the product type. The examples in
   * the help line come from an "Examples:" tag when there is one. */
  function initPairedTextField(product, form, anchorWrapper) {
    var type = productTypeOf(product);
    var names = PAIRED_TEXT_DEFAULT;
    for (var i = 0; i < PAIRED_TEXT_NAMES.length; i++) {
      if (type.indexOf(PAIRED_TEXT_NAMES[i].match) !== -1) {
        names = PAIRED_TEXT_NAMES[i];
        break;
      }
    }

    var examples = PAIRED_TEXT_DEFAULT_EXAMPLES;
    var tags = productTags(product);
    for (var t = 0; t < tags.length; t++) {
      if (normalise(tags[t]).indexOf(PAIRED_TEXT_EXAMPLES_PREFIX) === 0) {
        var rest = tags[t].slice(tags[t].indexOf(':') + 1).trim();
        if (rest) examples = rest;
        break;
      }
    }

    var wrapper = makeFieldWrapper();

    function makeBox(id, prop) {
      var row = document.createElement('div');
      row.style.marginBottom = '14px';

      var label = document.createElement('label');
      label.className = 'pName';
      label.setAttribute('for', id);
      label.textContent = prop;
      label.style.marginBottom = LABEL_GAP;

      var input = document.createElement('input');
      input.className = 'pBox';
      input.type = 'text';
      input.id = id;
      input.name = 'properties[' + prop + ']';
      input.setAttribute('maxlength', String(PAIRED_TEXT_MAX));
      input.setAttribute('autocomplete', 'off');
      input.style.display = 'block';

      row.appendChild(label);
      row.appendChild(input);
      wrapper.appendChild(row);

      return input;
    }

    var one = makeBox('wue-paired-one', names.one);
    var two = makeBox('wue-paired-two', names.two);

    var help = document.createElement('small');
    help.className = 'pHelp';
    // " / " reads as a list separator in a tag but as clutter on the page.
    help.textContent = examples.split(' / ').join(', ') + '.' + PAIRED_TEXT_HELP_TAIL;
    help.style.display = 'block';
    help.style.marginTop = HELP_GAP;

    var error = makeErrorLine();

    wrapper.appendChild(help);
    wrapper.appendChild(error);

    function validate(event) {
      var a = one.value.trim();
      var b = two.value.trim();
      if (a && b) { error.style.display = 'none'; return; }

      event.preventDefault();
      event.stopImmediatePropagation();
      error.textContent = a
        ? 'Please fill in ' + names.two + ' before adding to bag.'
        : 'Please fill in ' + names.one + ' before adding to bag.';
      error.style.display = 'block';
      (a ? two : one).focus();
    }

    if (anchorWrapper && anchorWrapper.parentNode) {
      anchorWrapper.parentNode.insertBefore(wrapper, anchorWrapper);
    } else {
      placeBeforeAddButton(form, wrapper);
    }

    form.addEventListener('submit', validate, true);
    var addBtn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', validate, true);
  }

  /* The family pieces: two initials boxes in place of one free-text
   * engraving. The piece reads PARENT ♡ PARENT = CHILD CHILD CHILD CHILD.
   *
   * Letters only, uppercased as typed. One or two parents (not every family
   * has two) and one to four children. */
  function initFamilyInitialsField(form, anchorWrapper) {
    var wrapper = makeFieldWrapper();

    function makeBox(id, prop, labelText, max, helpText) {
      var row = document.createElement('div');
      row.style.marginBottom = '14px';

      var label = document.createElement('label');
      label.className = 'pName';
      label.setAttribute('for', id);
      label.textContent = labelText;
      label.style.marginBottom = LABEL_GAP;

      var input = document.createElement('input');
      input.className = 'pBox';
      input.type = 'text';
      input.id = id;
      input.name = 'properties[' + prop + ']';
      input.setAttribute('maxlength', String(max));
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('spellcheck', 'false');
      input.style.display = 'block';
      input.style.textTransform = 'uppercase';
      input.style.letterSpacing = '0.1em';
      // .pBox is 50% of the form, far too wide for a handful of letters.
      input.style.width = (2.2 + max * 1.25).toFixed(2) + 'em';
      input.style.maxWidth = '100%';

      var help = document.createElement('small');
      help.className = 'pHelp';
      help.textContent = helpText;
      help.style.display = 'block';
      help.style.marginTop = HELP_GAP;

      row.appendChild(label);
      row.appendChild(input);
      row.appendChild(help);
      wrapper.appendChild(row);

      return input;
    }

    var parents = makeBox(
      'wue-family-parents', FAMILY_PARENTS_PROP,
      'Parents’ initials', 2, '2 letters only - in your preferred order.'
    );
    var children = makeBox(
      'wue-family-children', FAMILY_CHILDREN_PROP,
      'Children’s Initial(s)', 4, 'Up to 4 letters - in your preferred order.'
    );

    var preview = document.createElement('small');
    preview.className = 'pHelp';
    preview.style.display = 'block';
    preview.style.letterSpacing = '0.12em';

    var error = makeErrorLine();

    wrapper.appendChild(preview);
    wrapper.appendChild(error);

    function clean(input) {
      var v = input.value.replace(/[^A-Za-z]/g, '').toUpperCase();
      if (v !== input.value) input.value = v;
      return v;
    }

    function render() {
      var p = clean(parents);
      var c = clean(children);

      if (!p && !c) {
        preview.textContent = '';
        return;
      }

      var left = p.split('').join(' ' + FAMILY_HEART + ' ');
      var right = c.split('').join(' ');
      preview.textContent = 'Your piece: ' + (right ? left + ' = ' + right : left);

      if (p.length === 2 && c) error.style.display = 'none';
    }

    parents.addEventListener('input', render);
    children.addEventListener('input', render);

    function validate(event) {
      var p = clean(parents);
      var c = clean(children);
      if (p.length === 2 && c) { error.style.display = 'none'; return; }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!p) {
        error.textContent = 'Please add the parents’ initials before adding to bag.';
      } else if (p.length < 2) {
        error.textContent = 'Please add both parents’ initials before adding to bag.';
      } else {
        error.textContent = 'Please add the children’s initials before adding to bag.';
      }
      error.style.display = 'block';
      (p.length === 2 ? children : parents).focus();
    }

    if (anchorWrapper && anchorWrapper.parentNode) {
      anchorWrapper.parentNode.insertBefore(wrapper, anchorWrapper);
    } else {
      placeBeforeAddButton(form, wrapper);
    }

    form.addEventListener('submit', validate, true);
    var addBtn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', validate, true);

    render();
  }

  /* The Roman numeral pieces: three date boxes in place of one free-text
   * line, with the conversion done here rather than in the customer's head.
   *
   * The year box takes two or four digits, so 26 reads XXVI and 2026 reads
   * MMXXVI. Day, month and year reach the order as entered AND the converted
   * string rides along as its own property. */
  function initRomanDateField(form, anchorWrapper) {
    var wrapper = makeFieldWrapper();

    var row = document.createElement('div');
    row.style.display = 'flex';
    row.style.flexWrap = 'wrap';
    row.style.gap = '14px';
    wrapper.appendChild(row);

    function makeBox(id, prop, labelText, max) {
      var cell = document.createElement('div');

      var label = document.createElement('label');
      label.className = 'pName';
      label.setAttribute('for', id);
      label.textContent = labelText;
      label.style.marginBottom = LABEL_GAP;

      var input = document.createElement('input');
      input.className = 'pBox';
      input.type = 'text';
      input.id = id;
      input.name = 'properties[' + prop + ']';
      input.setAttribute('maxlength', String(max));
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('spellcheck', 'false');
      input.style.display = 'block';
      input.style.width = (2.6 + max * 1.1).toFixed(2) + 'em';
      input.style.maxWidth = '100%';

      cell.appendChild(label);
      cell.appendChild(input);
      row.appendChild(cell);

      return input;
    }

    var day = makeBox('wue-roman-day', ROMAN_DAY_PROP, 'Day', 2);
    var month = makeBox('wue-roman-month', ROMAN_MONTH_PROP, 'Month', 2);
    var year = makeBox('wue-roman-year', ROMAN_YEAR_PROP, 'Year', 4);

    var help = document.createElement('small');
    help.className = 'pHelp';
    help.textContent = 'Numbers only - please enter four digits for the full year.';
    help.style.display = 'block';
    help.style.marginTop = HELP_GAP;

    var preview = document.createElement('small');
    preview.className = 'pHelp';
    preview.style.display = 'block';
    preview.style.letterSpacing = '0.12em';
    preview.style.marginTop = '2px';

    var converted = document.createElement('input');
    converted.type = 'hidden';
    converted.name = 'properties[' + ROMAN_RESULT_PROP + ']';

    var error = makeErrorLine();

    wrapper.appendChild(help);
    wrapper.appendChild(preview);
    wrapper.appendChild(converted);
    wrapper.appendChild(error);

    function digits(input) {
      var max = parseInt(input.getAttribute('maxlength'), 10) || 4;
      var v = input.value.replace(/[^0-9]/g, '').slice(0, max);
      if (v !== input.value) input.value = v;
      return v;
    }

    function render() {
      var y = digits(year);
      var parts = [toRoman(digits(day)), toRoman(digits(month)), toRoman(y)];

      if (parts[0] && parts[1] && parts[2] && y.length === 4) {
        converted.value = parts.join(ROMAN_SEPARATOR);
        preview.textContent = 'Your date: ' + converted.value;
        error.style.display = 'none';
      } else {
        converted.value = '';
        preview.textContent = '';
      }
    }

    [day, month, year].forEach(function (input) {
      input.addEventListener('input', render);
    });

    function validate(event) {
      var d = parseInt(digits(day), 10);
      var m = parseInt(digits(month), 10);
      var y = parseInt(digits(year), 10);

      var message = '';
      var focusOn = null;

      if (!(d >= 1 && d <= 31)) {
        message = 'Please enter a day between 1 and 31.';
        focusOn = day;
      } else if (!(m >= 1 && m <= 12)) {
        message = 'Please enter a month between 1 and 12.';
        focusOn = month;
      } else if (!(y >= 1) || digits(year).length !== 4) {
        message = 'Please enter the year in full, as four digits.';
        focusOn = year;
      }

      if (!message) { error.style.display = 'none'; return; }

      event.preventDefault();
      event.stopImmediatePropagation();
      error.textContent = message;
      error.style.display = 'block';
      focusOn.focus();
    }

    if (anchorWrapper && anchorWrapper.parentNode) {
      anchorWrapper.parentNode.insertBefore(wrapper, anchorWrapper);
    } else {
      placeBeforeAddButton(form, wrapper);
    }

    form.addEventListener('submit', validate, true);
    var addBtn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', validate, true);

    render();
  }

  /* The photo upload. Shown only on variants whose card option is "your
   * photo", and add-to-cart is blocked until a file is chosen. */
  function initPhotoField(product, form, idInput) {
    var idx = cardOptionIndex(product);
    if (idx === -1) return;

    var allowed = {};
    var found = false;
    product.variants.forEach(function (variant) {
      if (isPhotoCard(variantOptionValues(variant)[idx])) {
        allowed[String(variant.id)] = true;
        found = true;
      }
    });
    if (!found) return;

    var wrapper = makeFieldWrapper();

    var label = document.createElement('label');
    label.className = 'pName';
    label.textContent = PHOTO_LABEL;
    label.style.marginBottom = LABEL_GAP;

    /* Clipped, NOT display:none — a hidden input cannot be focused, and the
     * field has to stay reachable by Tab and by input.focus() on the error
     * path. */
    var uid = 'wue-photo-' + (++PHOTO_UID);
    label.setAttribute('for', uid);

    var input = document.createElement('input');
    input.type = 'file';
    input.id = uid;
    input.name = 'properties[' + PHOTO_PROP + ']';
    /* HEIC is deliberately NOT listed. Safari decides whether to transcode an
     * iPhone photo partly from this attribute: with HEIC absent it hands over
     * a JPEG. Confirmed 4 Oct: iPhone photos arrive as JPEG. */
    input.setAttribute('accept', 'image/jpeg,image/png,image/webp');
    input.style.position = 'absolute';
    input.style.width = '1px';
    input.style.height = '1px';
    input.style.padding = '0';
    input.style.margin = '-1px';
    input.style.overflow = 'hidden';
    input.style.clip = 'rect(0 0 0 0)';
    input.style.whiteSpace = 'nowrap';
    input.style.border = '0';

    /* No .pBox class here — that class carries width:50%, which rendered the
     * picker at half the column. `font` is a SHORTHAND and resets
     * line-height, so it must be assigned BEFORE lineHeight. */
    var picker = document.createElement('label');
    picker.setAttribute('for', uid);
    picker.setAttribute('tabindex', '0');
    picker.setAttribute('role', 'button');
    picker.style.font = 'inherit';
    picker.style.lineHeight = '20px';
    picker.style.display = 'block';
    picker.style.boxSizing = 'border-box';
    picker.style.width = '100%';
    picker.style.cursor = 'pointer';
    picker.style.border = '1px solid #d3d3d3';
    picker.style.padding = '13px 20px';
    picker.style.background = 'transparent';
    picker.style.color = 'inherit';
    picker.style.textAlign = 'left';
    picker.style.overflow = 'hidden';
    picker.style.textOverflow = 'ellipsis';
    picker.style.whiteSpace = 'nowrap';

    var pickerText = document.createElement('span');
    pickerText.textContent = PHOTO_PLACEHOLDER;
    picker.appendChild(pickerText);

    picker.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        input.click();
      }
    });
    input.addEventListener('focus', function () {
      picker.style.outline = '2px solid #0b0b0b';
      picker.style.outlineOffset = '2px';
    });
    input.addEventListener('blur', function () {
      picker.style.outline = '';
      picker.style.outlineOffset = '';
    });

    var help = document.createElement('small');
    help.className = 'pHelp';
    help.textContent = PHOTO_HELP;
    help.style.display = 'block';
    help.style.marginTop = HELP_GAP;

    var error = makeErrorLine();

    wrapper.appendChild(label);
    wrapper.appendChild(picker);
    wrapper.appendChild(input);
    wrapper.appendChild(help);
    wrapper.appendChild(error);

    var anchor = findOptionWrapper(form, rawOptionNames(product)[idx]);
    if (!placeAfter(anchor, wrapper)) placeBeforeAddButton(form, wrapper);

    /* A comment node holds the slot so the field can be detached and put back
     * in exactly the same place. */
    var slot = document.createComment('wue-photo-field');
    wrapper.parentNode.insertBefore(slot, wrapper);
    wrapper.parentNode.removeChild(wrapper);
    var inForm = false;

    function setAttached(on) {
      if (on === inForm) return;
      if (on) {
        slot.parentNode.insertBefore(wrapper, slot.nextSibling);
      } else {
        wrapper.parentNode.removeChild(wrapper);
      }
      inForm = on;
    }

    function isOn() {
      return allowed[String(idInput.value)] === true;
    }

    function showChosen() {
      var file = input.files && input.files[0];
      pickerText.textContent = file ? file.name : PHOTO_PLACEHOLDER;
      picker.style.borderColor = file ? '#0b0b0b' : '#d3d3d3';
    }

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) { showChosen(); return; }
      if (file.size > PHOTO_MAX_BYTES) {
        error.textContent = 'That file is over 20MB. Please choose a smaller one.';
        error.style.display = 'block';
        input.value = '';
        showChosen();
        return;
      }
      error.style.display = 'none';
      showChosen();
    });

    function sync() {
      var on = isOn();
      if (!on) {
        input.value = '';
        error.style.display = 'none';
      }
      setAttached(on);
      showChosen();
    }

    /* Runs in the CAPTURE phase, so it gets the click before the theme's own
     * handler does. */
    function handleAdd(event) {
      if (!isOn()) return;

      if (!(input.files && input.files.length)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        error.textContent = PHOTO_ERROR_TEXT;
        error.style.display = 'block';
        picker.style.borderColor = '#b00020';
        input.focus();
        return;
      }

      /* A file is attached, so the theme's AJAX handler must not run — it
       * cannot submit a form containing one. form.submit() does not fire a
       * submit event, so this cannot recurse. */
      event.preventDefault();
      event.stopImmediatePropagation();
      error.style.display = 'none';
      form.submit();
    }

    onVariantChange(form, idInput, sync);

    form.addEventListener('submit', handleAdd, true);
    var addBtn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', handleAdd, true);

    sync();
  }

  /* The initials box. Its maxlength and width follow the selected count, and
   * add-to-cart is blocked until exactly that many letters are entered. */
 function initInitialsField(product,form,idInput){var names=optionNames(product),idx=names.indexOf(INITIALS_OPTION_NAME),fixed=parseInt(tagValueAfterPrefix(productTags(product),"initials:"),10);fixed>=1&&fixed<=9||(fixed=0);if(idx===-1&&!fixed)return;var counts={},found=!1;if(product.variants.forEach(function(variant){var n=fixed;if(!n){var raw=variantOptionValues(variant)[idx];n=parseInt(String(raw==null?"":raw).replace(/[^0-9]/g,""),10)}n>0&&(counts[String(variant.id)]=n,found=!0)}),!found)return;

    var wrapper = makeFieldWrapper();

    var label = document.createElement('label');
    label.className = 'pName';
    label.setAttribute('for', 'wue-initials');
    label.style.marginBottom = LABEL_GAP;

    var input = document.createElement('input');
    input.className = 'pBox';
    input.type = 'text';
    input.id = 'wue-initials';
    input.name = 'properties[' + INITIALS_PROP + ']';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');

    input.style.display = 'block';
    input.style.textTransform = 'uppercase';
    input.style.letterSpacing = '0.1em';
    input.style.maxWidth = '100%';

    var help = document.createElement('small');
    help.className = 'pHelp';
    help.style.display = 'block';
    help.style.marginTop = HELP_GAP;
    help.textContent = INITIALS_HELP;

    var error = makeErrorLine();

    wrapper.appendChild(label);
    wrapper.appendChild(input);
    wrapper.appendChild(help);
    wrapper.appendChild(error);

    var anchor = findOptionWrapper(form, rawOptionNames(product)[idx]);

    if (!placeAfter(anchor, wrapper)) {
      var cardInput = form.querySelector('#wue-custom-message');
      var cardWrapper = cardInput
        ? (cardInput.closest('.line-item-property__field') || null)
        : null;
      if (cardWrapper && cardWrapper.parentNode) {
        cardWrapper.parentNode.insertBefore(wrapper, cardWrapper);
      } else {
        placeBeforeAddButton(form, wrapper);
      }
    }

    function currentCount() {
      return counts[String(idInput.value)] || 0;
    }

    input.addEventListener('input', function () {
      var max = currentCount() || 1;
      var cleaned = input.value.replace(/[^A-Za-z]/g, '').toUpperCase();
      if (cleaned.length > max) cleaned = cleaned.slice(0, max);
      if (cleaned !== input.value) input.value = cleaned;
      if (cleaned.length === max) error.style.display = 'none';
    });

    function sync() {
      var n = currentCount();

      if (!n) {
        wrapper.style.display = 'none';
        wrapper.hidden = true;
        input.required = false;
        input.value = '';
        error.style.display = 'none';
        return;
      }

      wrapper.style.display = '';
      wrapper.hidden = false;
      input.required = true;
      input.setAttribute('maxlength', String(n));

      // Width only — height must not change.
      input.style.width = (2.2 + n * 1.25).toFixed(2) + 'em';

                  label.textContent = n === 1 ? 'Initial' : 'Initials';
                  help.style.display = n === 1 ? 'none' : 'block';

      if (input.value.length > n) input.value = input.value.slice(0, n);
      if (input.value.length !== n) error.style.display = 'none';
    }

    function validate(event) {
      var n = currentCount();
      if (!n) return;
      if (input.value.length === n) { error.style.display = 'none'; return; }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (input.value.length === 0) {
        error.textContent = n === 1
          ? 'Please add your initial before adding to bag.'
          : 'Please add your ' + n + ' initials before adding to bag.';
      } else {
        error.textContent = 'Please enter ' + n + ' letters — you have entered '
          + input.value.length + '.';
      }

      error.style.display = 'block';
      input.focus();
    }

    onVariantChange(form, idInput, sync);

    form.addEventListener('submit', validate, true);
    var addBtn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', validate, true);

    sync();
  }

  /* The text after the colon on the first tag starting with `prefix`, or ''.
   * Tags are matched case-insensitively but the value comes back as typed,
   * because some of these values are shown to the customer. */
  function tagValueAfterPrefix(tags, prefix) {
    for (var i = 0; i < tags.length; i++) {
      if (normalise(tags[i]).indexOf(prefix) !== 0) continue;
      var value = tags[i].slice(tags[i].indexOf(':') + 1).trim();
      if (value) return value;
    }
    return '';
  }

  /* One labelled box, built the way the scripted fields above build theirs:
   * label, input, help line, error line, dropped in where the theme's box
   * was. The three fields below differ only in their wording, their limit,
   * how they clean what is typed and what counts as valid, so they share
   * this rather than repeating it three times. */
  function buildSingleBox(form, anchorWrapper, spec) {
    var wrapper = makeFieldWrapper();
    var id = 'wue-' + spec.key;

    var label = document.createElement('label');
    label.className = 'pName';
    label.setAttribute('for', id);
    label.textContent = spec.label;
    label.style.display = 'block';
    label.style.marginBottom = LABEL_GAP;

    var input = document.createElement('input');
    input.className = 'pBox';
    input.type = 'text';
    input.id = id;
    input.name = 'properties[' + spec.prop + ']';
    input.required = true;
    input.style.display = 'block';
    if (spec.max) input.setAttribute('maxlength', String(spec.max));
    if (spec.inputMode) input.setAttribute('inputmode', spec.inputMode);
    if (spec.autocapitalize) input.setAttribute('autocapitalize', spec.autocapitalize);

    var help = document.createElement('small');
    help.className = 'pHelp';
    help.style.display = 'block';
    help.style.marginTop = HELP_GAP;
    help.textContent = spec.help;

    var error = makeErrorLine();
    error.textContent = spec.error;

    wrapper.appendChild(label);
    wrapper.appendChild(input);
    wrapper.appendChild(help);
    wrapper.appendChild(error);

    input.addEventListener('input', function () {
      if (spec.clean) {
        var cleaned = spec.clean(input.value);
        if (cleaned !== input.value) input.value = cleaned;
      }
      if (input.value.trim() !== '') error.style.display = 'none';
    });

    function validate(event) {
      var value = input.value.trim();
      if (value !== '' && (!spec.valid || spec.valid(value))) {
        error.style.display = 'none';
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      error.textContent = value === '' ? spec.error : (spec.invalidError || spec.error);
      error.style.display = 'block';
      input.focus();
    }

    if (anchorWrapper && anchorWrapper.parentNode) {
      anchorWrapper.parentNode.insertBefore(wrapper, anchorWrapper);
    } else {
      placeBeforeAddButton(form, wrapper);
    }

    form.addEventListener('submit', validate, true);
    var addBtn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', validate, true);

    return { wrapper: wrapper, input: input, help: help, error: error };
  }

  function initYearField(form, anchorWrapper) {
    buildSingleBox(form, anchorWrapper, {
      key: 'year',
      prop: YEAR_PROP,
      label: YEAR_LABEL,
      max: 4,
      inputMode: 'numeric',
      help: YEAR_HELP,
      error: YEAR_ERROR,
      invalidError: YEAR_INVALID,
      clean: function (value) { return value.replace(/[^0-9]+/g, '').slice(0, 4); },
      valid: function (value) { return /^([0-9]{2}|[0-9]{4})$/.test(value); }
    });
  }

  function initPostcodeField(form, anchorWrapper) {
    var built = buildSingleBox(form, anchorWrapper, {
      key: 'postcode',
      prop: POSTCODE_PROP,
      label: POSTCODE_LABEL,
      max: 8,
      autocapitalize: 'characters',
      help: POSTCODE_HELP,
      error: POSTCODE_ERROR,
      clean: function (value) {
        return value.toUpperCase()
          .replace(/[^A-Z0-9 ]+/g, '')
          .replace(/\s{2,}/g, ' ')
          .slice(0, 8);
      }
    });

    /* A warning, not a block. BFPO addresses, Gibraltar and the Crown
     * Dependencies all sit outside the standard pattern, and a customer who
     * knows their own postcode has to win over the regex. */
    function check() {
      var value = built.input.value.trim();
      var odd = value !== '' && !POSTCODE_PATTERN.test(value);
      built.help.textContent = odd ? POSTCODE_WARNING : POSTCODE_HELP;
      built.help.style.color = odd ? '#8a6100' : '';
    }

    built.input.addEventListener('input', check);
    built.input.addEventListener('blur', check);
  }

  function initMonogramField(form, anchorWrapper) {
    buildSingleBox(form, anchorWrapper, {
      key: 'monogram',
      prop: MONOGRAM_PROP,
      label: MONOGRAM_LABEL,
      max: MONOGRAM_MAX,
      autocapitalize: 'characters',
      help: MONOGRAM_HELP,
      error: MONOGRAM_ERROR,
      clean: function (value) {
        return value.toUpperCase().replace(/[^A-Z]+/g, '').slice(0, MONOGRAM_MAX);
      }
    });
  }

  /* The couple pieces: two initials boxes and a preview of the finished
   * piece, stacked with the rule between exactly as it is engraved. */
  function initCoupleInitialsField(product, form, anchorWrapper) {
    var perSide = parseInt(
      tagValueAfterPrefix(productTags(product), COUPLE_PER_SIDE_PREFIX), 10
    );
    if (!(perSide >= 1 && perSide <= 2)) perSide = COUPLE_PER_SIDE_DEFAULT;

    var wrapper = makeFieldWrapper();

    var row = document.createElement('div');
    row.style.display = 'flex';
    row.style.flexWrap = 'wrap';
    row.style.gap = '14px';
    wrapper.appendChild(row);

    function makeBox(id, prop, labelText) {
      var cell = document.createElement('div');

      var label = document.createElement('label');
      label.className = 'pName';
      label.setAttribute('for', id);
      label.textContent = labelText;
      label.style.marginBottom = LABEL_GAP;

      var input = document.createElement('input');
      input.className = 'pBox';
      input.type = 'text';
      input.id = id;
      input.name = 'properties[' + prop + ']';
      input.setAttribute('maxlength', String(perSide));
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('spellcheck', 'false');
      input.style.display = 'block';
      input.style.textTransform = 'uppercase';
      input.style.letterSpacing = '0.1em';
      input.style.width = (2.2 + perSide * 1.25).toFixed(2) + 'em';
      input.style.maxWidth = '100%';

      cell.appendChild(label);
      cell.appendChild(input);
      row.appendChild(cell);

      return input;
    }

    var topWord = perSide === 1 ? 'top initial' : 'top initial';
    var bottomWord = perSide === 1 ? 'bottom initial' : 'bottom initial';

    var top = makeBox('wue-couple-top', COUPLE_TOP_PROP,
      topWord.charAt(0).toUpperCase() + topWord.slice(1));
    var bottom = makeBox('wue-couple-bottom', COUPLE_BOTTOM_PROP,
      bottomWord.charAt(0).toUpperCase() + bottomWord.slice(1));

    var help = document.createElement('small');
    help.className = 'pHelp';
    help.style.display = 'block';
    help.style.marginTop = HELP_GAP;
    help.textContent = perSide === 1
      ? 'One letter each - engraved one above the other with a line inbetween.'
      : 'One letter each - engraved one above the other with a line inbetween.';

    /* The preview is the point of this field: it shows which pair sits above
     * the line, which is the thing a single box cannot say. */
    var preview = document.createElement('div');
    preview.style.display = 'none';
    preview.style.marginTop = '10px';
    preview.style.textAlign = 'center';
    preview.style.width = '4.5em';
    preview.style.letterSpacing = '0.12em';
    preview.style.fontSize = '1.1em';
    preview.style.lineHeight = '1.35';

    var previewTop = document.createElement('div');
    var previewRule = document.createElement('div');
    previewRule.style.borderTop = '1px solid currentColor';
    previewRule.style.margin = '2px 0';
    var previewBottom = document.createElement('div');

    preview.appendChild(previewTop);
    preview.appendChild(previewRule);
    preview.appendChild(previewBottom);

    var error = makeErrorLine();

    wrapper.appendChild(help);
    wrapper.appendChild(preview);
    wrapper.appendChild(error);

    function clean(input) {
      var v = input.value.replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, perSide);
      if (v !== input.value) input.value = v;
      return v;
    }

    function render() {
      var a = clean(top);
      var b = clean(bottom);

      if (!a && !b) {
        preview.style.display = 'none';
        return;
      }

      preview.style.display = 'block';
      previewTop.textContent = a || ' ';
      previewBottom.textContent = b || ' ';

      if (a && b) error.style.display = 'none';
    }

    top.addEventListener('input', render);
    bottom.addEventListener('input', render);

    function validate(event) {
      var a = clean(top);
      var b = clean(bottom);
      if (a && b) { error.style.display = 'none'; return; }

      event.preventDefault();
      event.stopImmediatePropagation();
      error.textContent = 'Please add the ' + (a ? bottomWord : topWord)
        + ' before adding to bag.';
      error.style.display = 'block';
      (a ? bottom : top).focus();
    }

    if (anchorWrapper && anchorWrapper.parentNode) {
      anchorWrapper.parentNode.insertBefore(wrapper, anchorWrapper);
    } else {
      placeBeforeAddButton(form, wrapper);
    }

    form.addEventListener('submit', validate, true);
    var addBtn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addBtn) addBtn.addEventListener('click', validate, true);

    render();
  }

  function initProduct(container) {
    var jsonEl = container.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var form = container.querySelector('form[data-product-form]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!product || !product.variants || !product.variants.length) return;

    var inputs = [];
    PERSONALISATION_PROPS.forEach(function (prop) {
      var input = form.querySelector('input[name="properties[' + prop + ']"]');
      if (input) inputs.push(input);
    });
    var offersCustomCard = product.variants.some(function (variant) {
      return variantOptionValues(variant).some(isNewRangeCard);
    });

    // Cosmetic, and independent of everything below.
    try {
      italiciseCustomCardOption(form);
      onVariantChange(form, idInput, function () { italiciseCustomCardOption(form); });
    } catch (e) {
      if (window.console && console.warn) console.warn('[Wue italics]', e);
    }

    // The photo field is independent of the message box and the tag chain.
    try { initPhotoField(product, form, idInput); } catch (e) {
      if (window.console && console.warn) console.warn('[Wue photo]', e);
    }

    /* Scripted replacements take the theme's boxes out before anything else
     * reads `inputs`. A product should carry at most one of these tags; if
     * it carries more, the first match wins. */
    var currentTags = productTags(product);
    var replacement = null;
    if (currentTags.indexOf(FAMILY_INITIALS_TAG) !== -1) {
      replacement = 'family';
    } else if (currentTags.indexOf(ROMAN_DATE_TAG) !== -1) {
      replacement = 'roman';
    } else if (currentTags.indexOf(PAIRED_TEXT_TAG) !== -1) {
      replacement = 'paired';
    } else if (currentTags.indexOf(YEAR_TAG) !== -1) {
      replacement = 'year';
    } else if (currentTags.indexOf(POSTCODE_TAG) !== -1) {
      replacement = 'postcode';
    } else if (currentTags.indexOf(MONOGRAM_TAG) !== -1) {
      replacement = 'monogram';
    } else if (currentTags.indexOf(COUPLE_INITIALS_TAG) !== -1) {
      replacement = 'couple';
    }

    if (replacement) {
      var stripped = stripThemePersonalisation(form, inputs);
      inputs = stripped.inputs;
      try {
        if (replacement === 'family') {
          initFamilyInitialsField(form, stripped.anchor);
        } else if (replacement === 'roman') {
          initRomanDateField(form, stripped.anchor);
        } else if (replacement === 'paired') {
          initPairedTextField(product, form, stripped.anchor);
        } else if (replacement === 'year') {
          initYearField(form, stripped.anchor);
        } else if (replacement === 'postcode') {
          initPostcodeField(form, stripped.anchor);
        } else if (replacement === 'monogram') {
          initMonogramField(form, stripped.anchor);
        } else {
          initCoupleInitialsField(product, form, stripped.anchor);
        }
      } catch (e) {
        if (window.console && console.warn) console.warn('[Wue ' + replacement + ']', e);
      }
    }

    if (!offersCustomCard && !inputs.length) {
      try { initInitialsField(product, form, idInput); } catch (e) {
        if (window.console && console.warn) console.warn('[Wue initials]', e);
      }
      return;
    }

    if (offersCustomCard) {
      /* Alphabet and other "Initials"-tagged products get a bare initials
       * input from the product.liquid tag chain. Where the scripted initials
       * field will take over, hide the theme box for good and take it out of
       * the group below; where it won't, leave it alone. */
      var hasScriptedInitials = optionNames(product).indexOf(INITIALS_OPTION_NAME) !== -1;
      var themeInitialsInput = form.querySelector('input[name="properties[initials]"]');
      if (hasScriptedInitials && themeInitialsInput) {
        var themeInitialsWrapper = themeInitialsInput.closest('.line-item-property__field') || themeInitialsInput.parentNode;
        if (themeInitialsWrapper) {
          themeInitialsWrapper.style.display = 'none';
          themeInitialsWrapper.hidden = true;
        }
        themeInitialsInput.required = false;
        /* The name has to go, not just the visibility. A hidden input that
         * keeps its properties[] name still posts, so every order carried a
         * blank "initials" line next to the real one. */
        themeInitialsInput.removeAttribute('name');
        inputs = inputs.filter(function (input) { return input !== themeInitialsInput; });
      }

      /* The card message is NOT pushed into `inputs`. It has its own name and
       * its own toggle, so that the engraving box beside it can stay visible
       * on every variant. */
      var cardInput = form.querySelector('#wue-custom-message')
        || buildCustomMessageField(form, product);
      try { initCardMessageField(product, form, idInput, cardInput); } catch (e) {
        if (window.console && console.warn) console.warn('[Wue card message]', e);
      }
    }

    try { initInitialsField(product, form, idInput); } catch (e) {
      if (window.console && console.warn) console.warn('[Wue initials]', e);
    }

    var wrappers = [];
    inputs.forEach(function (input) {
      var wrapper = input.closest('.line-item-property__field') || input.parentNode;
      if (wrapper && wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
    });
    if (!wrappers.length) return;

    // --- Correct the max length and label from the most specific tag -------
    var rule = null;
    for (var i = 0; i < TAG_RULES.length; i++) {
      if (currentTags.indexOf(TAG_RULES[i].tag) !== -1) { rule = TAG_RULES[i]; break; }
    }

    var labelOverride = tagValueAfterPrefix(currentTags, FIELD_LABEL_PREFIX);
    var mainInput = form.querySelector('input[name="properties[Personalisation]"]');
    if (mainInput && (rule || labelOverride)) {
      if (rule) mainInput.setAttribute('maxlength', String(rule.max));
      var label = (mainInput.closest('.line-item-property__field') || form)
        .querySelector('label');
      if (label) {
        if (labelOverride) {
          label.textContent = rule
            ? labelOverride + ' (max ' + rule.max + ' characters)'
            : labelOverride;
        } else {
          label.textContent = rule.label + ' (max. ' + rule.max + ' characters)';
        }
      }
    }

    /* --- Which variants show the engraving box ----------------------------
     *
     * Every one of them, unless this is a legacy product whose "yes ..."
     * option is what turns personalisation on, or an 'Engrave If:' tag names
     * the one option value that needs typing. */
    var engraveIf = normalise(tagValueAfterPrefix(currentTags, ENGRAVE_IF_PREFIX));

    var hasToggle = engraveIf !== '' || product.variants.some(function (variant) {
      return variantOptionValues(variant).some(isLegacyToggleValue);
    });

    var allowed = {};
    product.variants.forEach(function (variant) {
      var values = variantOptionValues(variant);
      var show;
      if (engraveIf !== '') {
        show = values.some(function (value) { return normalise(value) === engraveIf; });
      } else if (hasToggle) {
        show = values.some(isLegacyToggleValue);
      } else {
        show = true;
      }
      if (show) allowed[String(variant.id)] = true;
    });

    var alwaysVisible = !hasToggle;

    // --- Error message ----------------------------------------------------
    var error = makeErrorLine();
    error.textContent = ERROR_TEXT;
    wrappers[wrappers.length - 1].appendChild(error);

    function setVisible(show) {
      wrappers.forEach(function (wrapper) {
        wrapper.style.display = show ? '' : 'none';
        wrapper.hidden = !show;
      });
      inputs.forEach(function (input) {
        // required must come off while hidden, or the browser refuses to
        // submit a form containing an invalid control it cannot focus
        input.required = show;
        if (!show) input.value = '';
      });
      if (!show) error.style.display = 'none';
    }

    function sync() {
      setVisible(alwaysVisible || allowed[String(idInput.value)] === true);
    }

    function validate(event) {
      if (inputs[0].required !== true) return;
      var empty = inputs.some(function (input) { return input.value.trim() === ''; });
      if (!empty) { error.style.display = 'none'; return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      error.style.display = 'block';
      inputs[0].focus();
    }

    onVariantChange(form, idInput, sync);

    form.addEventListener('submit', validate, true);
    var addButton = form.querySelector('[name="add"], [data-add-to-cart]');
    if (addButton) addButton.addEventListener('click', validate, true);

    sync();
  }

  function init() {
    var containers = document.querySelectorAll('[data-product]');
    for (var i = 0; i < containers.length; i++) {
      try {
        initProduct(containers[i]);
      } catch (e) {
        if (window.console && console.warn) {
          console.warn('[Wue personalisation]', e);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
